import React from 'react';
import '../css/BusinessServicePage.css';

const ServiceInfo = () => {
  return (
    <div className="business-container">
      <h1 className="business-title">Halısahacım İşletmelere Özel Hizmetler</h1>
      <p className="business-description">
        Halısahacım, saha sahiplerine dijital bir platformda yer alma fırsatı sunar. Platformumuzda yer alan işletmeler;
      </p>
      <ul className="business-list">
        <li>Halı saha detaylarını ziyaretçilere sunabilir,</li>
        <li>Kullanıcıların rezervasyon taleplerini online olarak alabilir,</li>
        <li>İşletme takvimini dijital ortamda yönetebilir,</li>
        <li>Müşterileriyle anlık mesajlaşabilir,</li>
        <li>Kendi fotoğraflarını ve ekipman bilgilerini paylaşabilir.</li>
      </ul>

      <div className="payment-box">
        <h2 className="payment-title">Hizmet Ücreti</h2>
        <p className="payment-amount">İlk ay tamamen ücretsizdir. Sonraki dönemlerde hizmet ücreti <strong>1500₺</strong> olarak belirlenmiştir.</p>
        <p className="payment-note">Bu ücret sadece Halısahacım platformunda görünür olmak isteyen işletmelerden alınmaktadır.</p>
      </div>

      <div className="payment-button-container">
        <button className="go-payment-button" onClick={() => window.location.href = '/payment'}>
          Şimdi Ödeme Sayfasına Git
        </button>
      </div>
    </div>
  );
};

export default ServiceInfo;
